import axios, { type AxiosRequestConfig } from 'axios';
import { isEmpty, isNil } from 'lodash';
import { API_BASE_URL } from '../config/apiUrl';
import { roleListProps } from './GlobalContextProvider';

export interface ApiRequestOptions {
   basePath?: string;
   endpoint: string;
   body?: string | any;
   params?: object;
   method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';
   headers?: Record<string, string>;
   includeToken?: boolean;
}

const defaultHeaders: Record<string, string> = {
   'Content-Type': 'application/json',
   Accept: 'application/json',
};

export const apiRequest = async (props: ApiRequestOptions): Promise<any> => {
   const includeTokenVerify = () => {
      if (isNil(props.includeToken)) {
         return false;
      }
      return true;
   };


   const mergedHeaders = props.headers ? { ...props.headers } : defaultHeaders;
   if (getaccessToken() && includeTokenVerify()) {
      mergedHeaders.Authorization = `Bearer ${getaccessToken()}`;
   }else{
      delete mergedHeaders?.Authorization;
   }


   const config: AxiosRequestConfig = {
      url: `${props.basePath ?? API_BASE_URL}${props.endpoint}`,
      method: props.method,
      headers: mergedHeaders,
      params: props.params,
      data: props.body,
   };

   try {
      const response = await axios(config);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getaccessToken = (): string | null => {
   return sessionStorage.getItem('user-token');
};


export const checkAuthToken = (): boolean => {
   if (isNil(getaccessToken()) || isEmpty(getaccessToken()) || getaccessToken() === 'undefined') {
      return false;
   } else {
      return true;
   }
};

export const getUserName = (): string | null => {
   return sessionStorage.getItem('username');
};

export const getUserRoleId = () => {
   return sessionStorage.getItem('userRoleId');
}

export const getUserRoles = (): roleListProps[] | null => {
   const rolesString = sessionStorage.getItem('user-roles');
 
   if (!rolesString) {
     return null;
   }
 
   const roles = JSON.parse(rolesString);
   return roles;
 };
 
 export const checkUserRoles = (): boolean => {
   const userRoles = getUserRoles();
 
   return (
     !!userRoles &&
     userRoles.length > 0
   );
 };
 
 export const getUserRolesList = (): roleListProps[] | [] => {
   const userRoles = getUserRoles();
 
   if (checkUserRoles() && !isNil(userRoles)) {
     return userRoles;
   } else {
     return [];
   }
 };

export const authService = {
   isAuthenticated: () => {
      return checkAuthToken();
   },
   getUserRoles: () => {
      return getUserRolesList();
   },
};

export const getUserSelectedRole = (): string | null => {
   return sessionStorage.getItem('selectedRole');
};

export const getUserID = () : string | null => {
   return sessionStorage.getItem('userID');
};

export const getUserDetails = (): string | null => {
   return sessionStorage.getItem('name')
}
// errorHandler.ts

export function catchErrorMessageHandler(err: any): string {
   let ErrorMessage: string = "";

   if (!isNil(err.response)) {
      const data = err.response.data;

      switch (true) {
         case !isNil(data.detailedErrorMessage):
            ErrorMessage = data.detailedErrorMessage;
            break;
         case !isNil(data.errorMessage):
            ErrorMessage = data.errorMessage;
            break;
         case !isNil(data.errorCode):
            ErrorMessage = `${data.errorCode} ${data.status}`;
            break;
         case !isNil(data.detail):
            ErrorMessage = `${data.detail} ${data.status}`;
            break;
         case !isNil(data.error):
            ErrorMessage = `${data.error} ${data.status}`;
            break;
         default:
            ErrorMessage = err.message;
      }
   } else {
      ErrorMessage = err.message;
   }

   return ErrorMessage;
}

export const getDevoteeId = (): any | null => {
   return {
      userId:sessionStorage.getItem('devoteeID'),
      fullName:sessionStorage.getItem('devoteeFullname')
   }
}

export const validateEmail = (email:any) => {
   if (typeof email !== 'string') {
       return "Email must be a valid string.";
   } else if (email.length < 6) {
       return "Email must be at least 6 characters long.";
   } else if (email.length >= 64) {
       return "Email must be less than 64 characters long.";
   } else if (!email.includes("@")) {
       return "Please Enter Valid Email";
   } else {
       return "";
   }
};

export function formatWeekday(date: Date): string {
   const options: Intl.DateTimeFormatOptions = { weekday: 'long' };
   return date.toLocaleDateString('en-US', options);
}


